import { render, staticRenderFns } from "./SdsSection14Form.vue?vue&type=template&id=65a23493"
import script from "./SdsSection14Form.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsSection14Form.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports